module.exports = __webpack_public_path__ + "static/media/blackEmail.6fa45a23.svg";